import { type FC } from "react";
import * as styles from "./styles.css";

type Props = {
  reasonText: string;
  scoutIndexUrl: string;
};

export const AlertTextPanel: FC<Props> = ({ reasonText, scoutIndexUrl }) => (
  <div className={styles.alertTextPanelContainer}>
    {reasonText}
    <br />
    <a className={styles.indexLink} href={scoutIndexUrl}>
      スカウト検索
    </a>
    で他の求職者も探してみませんか？
  </div>
);
